import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'


const HD = [

    {
        "Name": "Dr. Subbareddy Daggumati",
        "NameLink": "/dr-subbareddy-daggumati",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Ghent University, Ghent, Belgium",
        "AreasofInterest": "Advanced Fibre Reinforced Composite Materials, Computational Solid Mechanics",
        "Email": "hod_me@iittp.ac.in / subbareddy.daggumati@iittp.ac.in",
        "Phone": "0877 250 3400 / 3416",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Subbareddy Daggumati.png"
    },

]
const Faculty = [




    {
        "Name": "Prof. Anil Kumar Emadabathuni",
        "NameLink": "/dr-anil-kumar-emadabathuni",
        "Position": "Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, Chennai, India.",
        "AreasofInterest": "Hydrogen Storage, Thermal Energy Storage, Adsorption Heating and Cooling Systems",
        "Email": "anil@iittp.ac.in",
        "Phone": "0877 250 3405",
        "Image": "https://files.iittp.ac.in/images/demo/iit/anil.jpg"
    },
    {
        "Name": "Prof. Muthukumar Palanisamy",
        "NameLink": "/prof-muthukumar-palanisamy",
        "Position": "Professor",
        "Degree": "Ph.D - Thermal Science and Hydrogen Energy, IIT Madras 2005.",
        "ThesisTitle": "Studies on Metal hydride based thermal devices for compression and storage of Hydrogen",
        "AreasofInterest": "Energy storage including hydrogen and thermal, Porous Medium combustion",
        "Email": "pmkumar@iittp.ac.in",
        "Phone": " ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg"
    },
        {
        "Name": "Prof. Mamilla Ravi Sankar",
        "NameLink": "/dr-mamilla-ravi-sankar",
        "Position": "Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India ",
        "AreasofInterest": " Advanced Materials and Manufacturing, Ultra Precision Machining ",
        "Email": " evmrs@iittp.ac.in",
        "Phone": " 0877 250 3410",
        "Image": "https://files.iittp.ac.in/images/demo/iit/EVMRS.JPG"
    },
    {
        "Name": "Prof. N. Venkaiah",
        "NameLink": "/dr-n-venkaiah",
        "Position": "Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Madras, India.",
        "AreasofInterest": "Computational Metrology, Machining, Optimization Techniques",
        "Email": "venkaiah@iittp.ac.in",
        "Phone": "0877 250 3035",
        "Image": "https://files.iittp.ac.in/images/demo/iit/venkaiah.jpg"
    },
     {
        "Name": "Dr. Anup Basak",
        "NameLink": "/dr-anup-basak",
        "Position": "Associate Professor",
        "Degree": "Ph.D - IIT Kanpur, India",
        "AreasofInterest": "Solid Mechanics, Computational Mechanics",
        "Email": "abasak@iittp.ac.in",
        "Phone": " ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Anup_Basak_photo.jpg"
    },
    {
        "Name": "Dr. Ajay Kumar",
        "NameLink": "/dr-ajay-kumar",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Science (IISc), Bangalore (KA) India",
        "AreasofInterest": "Metal Casting, Metal Forming, Materials Processing and Mechanical Behavior of Materials, Tribology",
        "Email": "drajaykumarp@iittp.ac.in",
        "Phone": "+91-6360201557",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Ajay Kumar.jpg"
    },
    {
        "Name": "Dr Balaji S",
        "NameLink": "/dr-balaji-subramanian",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Swiss federal Institute of Technology (ETH) Zurich, Switzerland",
        "AreasofInterest": "Wind energy, Experimental fluid mechanics/aerodynamics",
        "Email": "balaji@iittp.ac.in",
        "Phone": "0877 250 3406",
        "Image": "https://files.iittp.ac.in/images/demo/iit/balajisub.png"
    },
    {
        "Name": "Dr. Degala Venkata Kiran",
        "NameLink": "/dr-degala-venkata-kiran",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Bombay, India",
        "AreasofInterest": "Welding science and technology",
        "Email": "dvkiran@iittp.ac.in",
        "Phone": "0877 250 3407",
        "Image": "https://files.iittp.ac.in/images/demo/iit/D.V. Kiran.jpg"
    },
    {
        "Name": "Dr. Girish Kumar Rajan",
        "NameLink": "/dr-girish-kumar-rajan",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Pennsylvania State University, PA, USA",
        "AreasofInterest": "Fluid Mechanics, Hydrodynamics, Applied Mathematics, and CFD",
        "Email": "gkrajan@iittp.ac.in",
        "Phone": "0877 250 3408",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Girish.jpg"
    },
    {
        "Name": "Dr. N. Gnanasekaran",
        "NameLink": "/dr-n-gnanasekaran",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Inverse Heat Transfer",
        "Email": "gnanasekaran@iittp.ac.in",
        "Phone": " ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_N_Gnanasekaran_ASP.png"
    },
    {
        "Name": "Dr. Madan Mohan Avulapati",
        "NameLink": "/dr-madan-mohan-avulapati",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Science (IISc), Bangalore, India",
        "AreasofInterest": "Liquid atomization, Combustion, Alternative fuels for IC engines and gas turbines",
        "Email": "madan.avulapati@iittp.ac.in",
        "Phone": "0877 250 3409",
        "Image": "https://files.iittp.ac.in/images/demo/iit/madan_new.jpg"
    },
    {
        "Name": "Dr. Sriram Sundar",
        "NameLink": "/dr-sriram-sundar",
        "Position": "Associate Professor",
        "Degree": "Ph.D - The Ohio State University, Columbus, Ohio, U.S.A.",
        "AreasofInterest": "Vibrations, Contact mechanics, Gear and brake dynamics",
        "Email": "sriram@iittp.ac.in",
        "Phone": "0877 250 3411",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Sriram_Sundar.JPG"
    },
    
   
    {
        "Name": "Dr. P. Venkataraman",
        "NameLink": "/dr-p-venkataraman",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Nanyang Technological University, Singapore",
        "AreasofInterest": "Computational mechanics, Natural fiber composites, Auxetic materials, Machine learning",
        "Email": "raman@iittp.ac.in",
        "Phone": "0877 250 3413",
        "Image": "https://files.iittp.ac.in/images/demo/iit/pandurangan.jpg"
    },
    {
        "Name": "Dr. Abir Dutta",
        "NameLink": "/dr-abir-dutta",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kharagpur, India",
        "AreasofInterest": "Orthopedic Biomechanics, Finite Element Analysis",
        "Email": "abir.dutta@iittp.ac.in",
        "Phone": "0877 250 3420",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Abir_Dutta_AP.png"
    },
   
   

     {
        "Name": "Dr. Ajay Kumar Kalyani",
        "NameLink": "/dr-ajay-kumar-kalyani",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - IISc Bangalore, India",
        "AreasofInterest": "Advanced Electronic and Structural Ceramics",
        "Email": "kalyani.ajay@iittp.ac.in",
        "Phone": "0877 250 3414",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Ajay_Kumar_Kalyani_ME.jpg"
    },
   
   
    
    {
        "Name": "Dr. Govind Narayan Sahu",
        "NameLink": "https://smalab.org/",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Kanpur, India",
        "AreasofInterest": "Machining Dynamics, Smart Machine Tool System",
        "Email": "govinds@iittp.ac.in",
        "Phone": "0877 250 3419",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Govind_N_Sahu.jpg"
    },
    {
        "Name": "Dr. Mohd Furquan",
        "NameLink": "/dr-mohd-furquan",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India",
        "AreasofInterest": "Computational Mechanics, Fluid-Structure Interaction",
        "Email": "mfurquan@iittp.ac.in",
        "Phone": " ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Mohd_Furquan_AP.png"
    },
    {
        "Name": "Dr. Srinivasa Krishna Addepalli",
        "NameLink": "/dr-srinivasa-krishna-addepalli",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Computational Fluid Dynamics (CFD), Carbon-less Fuels for Transportation",
        "Email": "as_krishna@iittp.ac.in",
        "Phone": "0877 250 3418",
        "Image": "https://files.iittp.ac.in/images/demo/iit/as_krishna.jpg"
    },
    
    
    {
        "Name": "Dr. Thiyagarajan R",
        "NameLink": "/dr-thiyagarajan",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras (IIT-M), Chennai, India",
        "AreasofInterest": "Robotics and automation, Dynamics and control of field and service robots, Mechatronics, Additive manufacturing",
        "Email": "thiyagu@iittp.ac.in",
        "Phone": " ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/thiyagarajan.jpeg"
    },

    {
        "Name": "Dr. Vignesh T G",
        "NameLink": "/dr-vignesht-t-g",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Technische Universität Darmstadt, Germany",
        "AreasofInterest": "Multiphase flows",
        "Email": "vigneshtg@iittp.ac.in",
        "Phone": "0877 250 3421",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Vignesh_T_G_AP.png"
    },
    
    {
        "Name": "Dr. Yujendra Mitikiri",
        "NameLink": "/dr-yujendra-mitikiri",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - University of Florida, Gainesville, 2020",
        "AreasofInterest": "Robotics, controls, analog circuits",
        "Email": "yujendra@iittp.ac.in",
        "Phone": "0877 250 3415",
        "Image": "https://files.iittp.ac.in/images/demo/iit/mitikiri.png"
    }



   
    




]

const AdjunctFaculty = [


    {
        "Name": "Prof. N. N. Kishore",
        "NameLink": "/dr-n-n-kishore",
        "Position": "Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Kanpur, India.",
        "AreasofInterest": "Composite Materials, FEM and Non-Destructive Testing",
        "Phone": "0877 250 3012",
        "Email": "nnk@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/nnk.jpg"
    },
    {
        "Name": "Dr. Ahmad Al-Mallahi",
        "NameLink": "https://www.dal.ca/faculty/agriculture/engineering/faculty-staff/our-faculty/ahmad-almallahi.html",
        "Position": "Industry Research Chair and Associate Professor",
        "Degree": "Ph.D - Bioproduction Engineering, Hokkaido University.",
        "AreasofInterest": "Precision Agriculture, Sensing and Automation, Digital Agriculture, Field Monitoring, Machine vision",
        "Phone": "",
        "Email": "ahmad.almallahi@dal.ca",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Ahmad-al-mallahi.png"
    }
   


]


const GuestFaculty = [


    {
        "Name": "Prof. V R Ganesan",
        "NameLink": "#",
        "Position": "Professor of Practice",
        "Degree": "M.Tech Mechanical Engineering (Solid Mechanics & Design), IIT Kanpur.",
        "AreasofInterest": "Automotives, New Technologies in Mechanical Engg, Alternate forms of mobility, Active Safety in automobiles, Digital Transformation",
        "Phone": "",
        "Email": "vrganesan@iitr.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Ganesan V R.png"
    },
    {
        "Name": "Dr. P.K. Ghosh",
        "NameLink": "#",
        "Position": "",
        "Degree": "Ph.D - Indian Institute of Technology Roorkee.",
        "AreasofInterest": "Welding Metallurgy, Fatigue & Fracture mechanics, Met. matrix composites, Innovation & IP Management, Welding & adhesive joining, Nano filler polymer composite, Life & Safety Analyses of Eng. Structure",
        "Phone": "",
        "Email": "prakgfmt@iitr.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_P_K_Ghosh.jpg"
    },
    {
        "Name": "Dr. GL. Samuel",
        "NameLink": "https://home.iitm.ac.in/samuelgl/",
        "Position": "",
        "Degree": "Ph.D - Indian Institute of Technology Madras.",
        "AreasofInterest": "Micro machining, Laser Micro Machining. Micro EDM",
        "Phone": "",
        "Email": "samuelgl@iitm.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Samuel.jfif"
    },
    {
        "Name": "Dr. Suresh Varadarajan",
        "NameLink": "#",
        "Position": "",
        "Degree": "Ph.D - Marquette University, WI, USA",
        "AreasofInterest": "Product Management, Smart Manufacturing, IIOT, Data Analytics",
        "Phone": "",
        "Email": "sureshv@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Suresh_Varadarajan.jpg"
    },
    {
        "Name": "Dr. K.L.Narayana",
        "NameLink": "https://files.iittp.ac.in/images/demo/iit/pdfs/prof.-KLN.pdf",
        "Position": "Professor (Rtd.)",
        "Degree": "Ph.D - Sri Venkateswara University, Tirupati, India.",
        "AreasofInterest": "Drawing, Production",
        "Phone": "",
        "Email": "klnarayana@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/KLP.png"
    }



]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="MECHANICAL ENGINEERING" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> People
                                </h5>
                                <h3>MECHANICAL ENGINEERING</h3>
                            </div>
                        </div>
                    </div>


                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={8} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((Faculty, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to="#">
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {Faculty.AreasofInterest}</p>
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {Faculty.AreasofInterest}</p>
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                                 {/*--------------------------- Adjunct Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Adjunct Faculty</h3>
                                {AdjunctFaculty.map((AdjunctFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={AdjunctFaculty.NameLink}>
                                                        <img src={AdjunctFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={AdjunctFaculty.NameLink}>{AdjunctFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{AdjunctFaculty.Position}</p>
                                                    <p className="text-dark">{AdjunctFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {AdjunctFaculty.AreasofInterest}</p>
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {AdjunctFaculty.Email}</p>
                                                    {(AdjunctFaculty.Phone !== undefined && AdjunctFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{AdjunctFaculty.Phone}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>



                            {/*--------------------------- Guest Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Guest Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {GuestFaculty.AreasofInterest}</p>
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}
export default Main